// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import '@/assets/js/flexible.js'
// import '@/assets/js/weixinShare.js'
import '@/assets/js/base64.code'
import Prius from '@/assets/js/jsBridge'
import { finderEvtCollect } from '@/assets/js/finder'
import config from '@/config/config'

window.Prius = Prius
window.localStorage.setItem('version', '2.6.0') // 埋点默认版本号

finderEvtCollect('init', {
    app_id: config.finderId, // 申请应用的 appid
    channel_domain: 'https://finder-snssdk.yaduo.com',
    spa: true,
    log: false, // true:开启日志，false:关闭日志
    autotrack: true // 全埋点开关，true开启，false关闭
    // Native: true
})
finderEvtCollect('config', {
    system_from_key: config.system,
    evtParams: {
        app_channel: 'Atour_H5' // 设定自定义公共属性
    }
})
// 此处可添加设置uuid、设置公共属性等代码
finderEvtCollect('start') // 通知SDK设置完毕，可以真正开始发送事件了

Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use(ElementUI)
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js